import { put, call, takeLatest } from "redux-saga/effects";
import { sensorTotalDataConstants } from "../../constants/client";
import { callAPI } from "../commonApiCall";
import apiURLs from "../../config/url-config";
import { sensorTotalData, alertActions } from "../../actions";

function* totalData(action) {
  try {
    const data = yield call(
      callAPI,
      apiURLs.sensorsUrl.totalData,
      action.payload
    );

    if (data.status === true) {
      yield put(
        sensorTotalData.totalDataSuccess({
          data: data.data,
        })
      );
    } else {
      yield put(alertActions.error(data.message));
    }
  } catch (error) {
  }
}


export function* sensorTotalDataSaga() {
  yield takeLatest(sensorTotalDataConstants.AVG_DATA_REQUEST, totalData);
}
